<template>
	<div class="baseInfo">
		<el-form label-position="left" :model="ruleForm" ref="ruleForm" label-width="200px">
			<el-form-item :label="$t('settings.avatar')">
				<div class="presonPic">
					<img v-if="selectFileOrNot" :src="previewImgURL" class="avatar" />
					<uploader
						:options="uploadOptions"
						:autoStart="true"
						ref="uploader"
						:file-status-text="statusText"
						@files-submitted="fileSubmit"
						@file-removed="fileRemoved"
						@file-success="fileSuccess"
						@file-error="fileFail"
						class="uploader-broadcast"
					>
						<uploader-unsupport></uploader-unsupport>
						<uploader-btn :directory="false" :attrs="attrs" :single="true"><i class="tipWord">{{ $t('settings.replace') }}</i></uploader-btn>
					</uploader>
				</div>
			</el-form-item>
			<el-form-item :label="$t('settings.loginAcc')">
				<p>{{ loginAccount }}</p>
			</el-form-item>
			<el-form-item
				:label="$t('register.username')"
				prop="name"
				:maxlength="isEnglish ? parseInt(40) : parseInt(20)"
				:rules="{ message: $t('settings.relName'), trigger: 'blur' }">
				<el-input v-model.trim="ruleForm.name" :maxlength="isEnglish ? parseInt(40) : parseInt(20)" :placeholder="$t('settings.relName')"></el-input>
			</el-form-item>
			<el-form-item	:label="$t('register.department')">
				<p>{{ ruleForm.user_org_name }}</p>
			</el-form-item>
			<el-form-item	:label="$t('form.position')">
				<p>{{ ruleForm.user_position_name }}</p>
			</el-form-item>
			<el-form-item :label="$t('register.gender')">
				<template>
					<el-radio-group v-model="ruleForm.sex">
						<el-radio :label="1">{{ $t('register.male') }}</el-radio>
						<el-radio :label="2">{{ $t('register.female') }}</el-radio>
					</el-radio-group>
				</template>
			</el-form-item>
			<el-form-item
				:label="$t('form.email')"
				prop="email"
				:rules="[{ message: $t('form.email1'), trigger: 'blur' }, { type: 'email', message: $t('form.rightEmail'), trigger: ['blur', 'change'] }]"
			>
				<el-input :maxlength="parseInt(100)" v-model.trim="ruleForm.email" :placeholder="$t('form.email1')"></el-input>
			</el-form-item>
			<el-form-item
				:label="$t('form.phone')"
				prop="telphone"
				:rules="[
					{ message: $t('form.phone1'), trigger: 'blur' },
					{ pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: $t('form.rightPhone'), trigger: 'blur' }
				]"
			>
				<el-input :maxlength="parseInt(11)" v-model="ruleForm.telphone" autocomplete="off" :placeholder="$t('form.phone1')"></el-input>
			</el-form-item>
			<el-form-item :label="$t('settings.intro')" class="introduce-item">
				<el-input type="textarea" :rows="6" resize="none" v-model.trim="autograph" :placeholder="$t('settings.introTip')" maxlength="60"></el-input>
				<span class="word-sum">
					<i>{{ autograph.length }}</i>
					<i>/60</i>
				</span>
			</el-form-item>
			<el-form-item class="submit-item"><el-button type="primary" size="medium" @click="submit('ruleForm')">{{ $t('global.save') }}</el-button></el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loginAccount: '',
			autograph: '',
			user_id: null,
			ruleForm: {
				name: '',
				sex: '0',
				email: '',
				telphone: '',
				user_position_name: '',
				user_org_name: ''
			},
			// 头像
			statusText: {
				success: this.$t('upload.success'),
				error: this.$t('upload.error'),
				uploading: this.$t('upload.uploading'),
				paused: this.$t('upload.paused'),
				waiting: this.$t('upload.waiting'),
			},
			selectFileOrNot: false, //是否选中文件
			uploadOrNot: false, //是否已经上传
			uploadInfo: {
				file_name: '',
				file_path: '',
				file_size: 0
			},
			attrs: {
				accept: ['image/*']
			},
			uploadOptions: {
				target: this.BASE_URL + '/api/resource/res_upload',
				testChunks: false,
				headers: { Authorization: `Bearer ` + this.$g.access_token }
			},
			selectFileShow: true, //是否显示选择文件按钮
			uploadRetryTimes: 100, //文件最大重传次数
			previewImgURL: ''
		};
	},
	created() {
		this.getinfo();
	},
	mounted() { },
	computed: {
		isEnglish() {
			return this.$i18n.locale === 'en-us'
		}
	},
	methods: {
		getinfo() {
			let success = res => {
				this.$store.commit('SET_USERINFO', res.data.userinfo);
				console.log(res.data.userinfo)
				this.loginAccount = res.data.userinfo.number;
				this.ruleForm.name = res.data.userinfo.name;
				this.ruleForm.user_org_name = res.data.userinfo.user_org_name;
				this.ruleForm.user_position_name = res.data.userinfo.user_position_name;
				this.ruleForm.sex = res.data.userinfo.sex;
				this.user_id = res.data.userinfo.id;
				this.autograph = res.data.userinfo.autograph;
				this.uploadInfo.file_path = res.data.userinfo.avatar_path;
				this.ruleForm.email = res.data.userinfo.email;
				this.ruleForm.telphone = res.data.userinfo.telphone;
				if (res.data.userinfo.avatar_path != '') {
					if (res.data.userinfo.avatar_path.includes('/static/default/user_preview-1.png') || res.data.userinfo.avatar_path.includes('/public/picture')) {
						res.data.userinfo.avatar_path = this.BASE_URL + res.data.userinfo.avatar_path
					}
					this.previewImgURL = res.data.userinfo.avatar_path;
					this.selectFileOrNot = true;
				}
			};
			this.$ajax({
				url: 'api/login/new_login',
				method: 'get',
				params: {},
				func: { success: success }
			});
		},

		// 表单验证
		submit(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.sendUserInfo();
				} else {
					console.log('error submit!!');
					return false;
				}
			});

		},
		//若验证通过，提交数据
		sendUserInfo() {
			let success = res => {
				this.$message.success(res.msg);
				this.getinfo();
			};
			this.$ajax({
				url: 'api/login/change_user_message',
				method: 'put',
				data: {
					name: this.ruleForm.name,
					autograph: this.autograph,
					avatar_path: this.uploadInfo.file_path,
					sex: this.ruleForm.sex,
					user_id: this.user_id,
					email: this.ruleForm.email,
					telphone: this.ruleForm.telphone
				},
				func: { success: success }
			});
		},
		//上传成功的事件
		fileSuccess(rootFile, file, message, chunk) {
			var mess = eval('(' + message + ')');
			mess = handleResponseData(mess);
			if (parseInt(mess.data.status) === 1) {
				this.uploadOrNot = true;
				this.uploadInfo.file_name = mess.data.file_name;
				this.uploadInfo.file_path = mess.data.file_path;
				this.uploadInfo.post_fix = mess.data.post_fix;
				// console.log(this.uploadInfo.file_path);
			}
		},
		fileFail(rootFile, file, message, chunk) {
			var mess = eval('(' + message + ')');
			if (parseInt(mess.error) === 401 && this.uploadRetryTimes > 0) {
				let callbcak = data => {
					this.uploadRetryTimes--;
					this.$refs.uploader.uploader.retry(file);
				};
				this.get_access_token(callbcak);
			} else {
				this.$message.error(mess.msg);
			}
		},
		//过滤文件格式
		fileSubmit(files, fileList, event) {
			for (var i = 0; i < fileList.length; i++) {
				if (fileList[i].fileType.indexOf('image/') === -1) {
					this.$message.warning(this.$t('upload.imgType'));
					this.$refs.uploader.uploader.removeFile(fileList[i]);
				} else if (fileList[i].size > 2048000) {
					this.$message.warning(this.$t('upload.score2M'));
					this.$refs.uploader.uploader.removeFile(fileList[i]);
				} else {
					if (this.$refs.uploader.uploader.fileList.length > 1) {
						//删除第一张图片
						this.$refs.uploader.uploader.removeFile(this.$refs.uploader.uploader.fileList[0]);
					}
					this.previewImgURL = window.URL.createObjectURL(fileList[i].file);
					// this.ruleForm.select_or_not = "1";
					this.uploadInfo.file_size = fileList[i].size;
					this.selectFileOrNot = true;
					this.selectFileShow = false;
				}
			}
		},
		fileRemoved(file) {
			// this.ruleForm.select_or_not = "";
			this.selectFileOrNot = false;
			this.selectFileShow = true;
		},
		fileUpload() {
			this.$refs.uploader.uploader.upload();
		}
	}
};
</script>

<style lang="scss">
.baseInfo {
	padding: 50px;
	width: 820px;

	.introduce-item {
		.el-form-item__content {
			position: relative;
		}

		.word-sum {
			position: absolute;
			right: 20px;
			bottom: 6px;

			i:nth-child(2) {
				color: #c0c4cc;
			}
		}
	}

	.submit-item {
		// padding-top: 50px;
		margin-bottom: 10px;
		text-align: left;

		.el-form-item__content {
			>button {
				border-color: #E62126;
				background: #E62126;
				transform: translate(-100px);
			}
		}
	}
}

//上传头像
.presonPic {
	width: 60px;
	height: 60px;
	border-radius: 50%;
	overflow: hidden;
	cursor: pointer;
	background-color: #f5f7fa;
	position: relative;

	>img {
		width: 100%;
		height: 100%;
	}

	.uploader {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
	}

	.uploader-btn {
		border: 0;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: block;
		padding: 0;
		text-align: center;

		.tipWord {
			display: inline-block;
			text-align: center;
			width: 100%;
			height: 100%;
			line-height: 60px;
			color: #fff;
			opacity: 0;
			transition: opacity 0.5s ease;
		}
	}

	&:hover .tipWord {
		opacity: 1;
	}
}</style>
